import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

// eslint-disable-next-line jira/export/no-external-exports
export type { ReleaseBar } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/roadmap/timeline/release-bar/types';

export const getReleaseBarState = (state: State) => state.ui.Main.Tabs.Roadmap.Timeline.ReleaseBar;
